import { getObjectLabelPropertyName, getPropertyValue } from './properties';
import formatName from 'I18n/utils/formatName';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
const getContactLabel = contact => {
  const firstName = getPropertyValue(contact, 'firstname');
  const lastName = getPropertyValue(contact, 'lastname');
  const email = getPropertyValue(contact, 'email');
  return formatName({
    firstName,
    lastName
  }) || email;
};
const getCompanyLabel = company => {
  const name = getPropertyValue(company, 'name');
  const domain = getPropertyValue(company, 'domain');
  return name || domain;
};
export const getRecordLabel = (objectTypeDef, subject) => {
  if (objectTypeDef.objectTypeId === CONTACT_TYPE_ID) {
    return getContactLabel(subject);
  } else if (objectTypeDef.objectTypeId === COMPANY_TYPE_ID) {
    return getCompanyLabel(subject);
  }
  const primaryDisplayLabelPropertyName = getObjectLabelPropertyName(objectTypeDef);
  let label;
  if (primaryDisplayLabelPropertyName) {
    label = getPropertyValue(subject, primaryDisplayLabelPropertyName);
  }
  return label || '--';
};